import dayjs from 'dayjs';
const utc = require('dayjs/plugin/utc');
dayjs.extend(utc);
export const zeropad = function (number, amount) {
  if (number >= 10 ** amount) {
    return number;
  }
  return (Array(amount).join(0) + number).slice(-amount);
};

export const uuid = function () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = parseInt(Math.random() * 16, 10);
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const getQueryString = function (name) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
  const r = window.location.search.substr(1).match(reg);
  if (r !== null) return r[2];
  return null;
};

export const getRoute = function () {
  const index = location.hash.indexOf('?');
  if (location.hash.match(/^#/)) {
    return index === -1 ? location.hash : location.hash.substr(0, index);
  }
  return '';
};

export const randomGameArr = function (arr, ranNum) {
  const result = [];
  if (arr.length >= ranNum) {
    for (let i = 0; i < ranNum; i++) {
      const ran = Math.floor(Math.random() * arr.length);
      result.push(arr.splice(ran, 1)[0]);
    }
  }
  return result;
};
export const dateFormat = function (date, format = 'MM.DD') {
  if (!date) return '';
  return dayjs().utcOffset(8).format(format);
};

// 弹窗禁止滚动
export function dialogNoScroll(value) {
  const className = 'page-out-fbscroll';
  const el = document.body;
  if (value) {
    el.classList.add(className);
  } else {
    el.classList.remove(className);
  }
}
